import { useState } from 'react';
import FadeInSection from '../../../components/feature/FadeInSection';

interface FaqItem {
  question: string;
  answer: string;
}

interface HomeFaqSectionProps {
  faqItems: FaqItem[];
}

export default function HomeFaqSection({ faqItems }: HomeFaqSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="section-padding" style={{ background: '#fff8f2' }} aria-label="よくある質問">
      <div className="content-width">
        <FadeInSection className="text-center mb-8 md:mb-14">
          <p
            className="inline-block px-4 py-1 rounded-full mb-4 text-sm font-bold"
            style={{ background: '#fff8f2', color: '#8b4513', border: '1px solid #d4a574' }}
          >
            FAQ
          </p>
          <h4 id="faq-section">
            <a href="#faq-section" className="text-inherit no-underline hover:no-underline" style={{ color: '#4a3728' }}>
              <strong>よくある質問</strong>
            </a>
          </h4>
          <p style={{ color: '#6b5a4e', marginTop: '10px', fontSize: '15px' }}>
            東京シニア婚活についてのよくあるご質問にお答えします
          </p>
        </FadeInSection>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, index) => (
            <FadeInSection key={index} delay={index * 80}>
              <article
                className="rounded-lg overflow-hidden cursor-pointer"
                style={{ border: '1px solid #e8d5c0', background: '#fff' }}
                itemScope
                itemType="https://schema.org/Question"
              >
                <button
                  type="button"
                  className="w-full text-left px-5 py-4 flex items-start justify-between gap-4 hover:opacity-80 transition-opacity"
                  onClick={() => toggle(index)}
                  aria-expanded={openIndex === index}
                  aria-controls={`faq-answer-${index}`}
                >
                  <div className="flex items-start gap-3 flex-1">
                    <span
                      className="flex-shrink-0 flex items-center justify-center w-7 h-7 rounded-full text-sm font-bold mt-0.5"
                      style={{ background: '#e8934e', color: '#fff' }}
                    >
                      Q
                    </span>
                    <span
                      className="font-bold leading-relaxed"
                      style={{ color: '#4a3728', fontSize: 'clamp(13px, 1.8vw, 16px)' }}
                      itemProp="name"
                    >
                      {item.question}
                    </span>
                  </div>
                  <span
                    className="flex-shrink-0 flex items-center justify-center w-6 h-6 mt-0.5 transition-transform duration-300"
                    style={{
                      color: '#8b4513',
                      transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    }}
                  >
                    <i className="ri-arrow-down-s-line text-xl"></i>
                  </span>
                </button>

                <div
                  id={`faq-answer-${index}`}
                  className="overflow-hidden transition-all duration-300"
                  style={{
                    maxHeight: openIndex === index ? '400px' : '0',
                    opacity: openIndex === index ? 1 : 0,
                  }}
                  itemScope
                  itemType="https://schema.org/Answer"
                >
                  <div
                    className="px-5 pb-5 flex items-start gap-3"
                    style={{ borderTop: '1px solid #f0e0cc' }}
                    itemProp="text"
                  >
                    <span
                      className="flex-shrink-0 flex items-center justify-center w-7 h-7 rounded-full text-sm font-bold mt-4"
                      style={{ background: '#5a9e6f', color: '#fff' }}
                    >
                      A
                    </span>
                    <p
                      className="mt-4 leading-relaxed"
                      style={{ color: '#6b5a4e', fontSize: 'clamp(13px, 1.6vw, 15px)' }}
                    >
                      {item.answer}
                    </p>
                  </div>
                </div>
              </article>
            </FadeInSection>
          ))}
        </div>

        <FadeInSection className="text-center mt-10">
          <a
            href="/faq"
            style={{
              color: '#8b4513',
              fontSize: '15px',
              fontWeight: '600',
              borderBottom: '1px solid #d4a574',
              paddingBottom: '2px',
            }}
            className="hover:opacity-70 transition-opacity whitespace-nowrap inline-flex items-center gap-1"
          >
            よくある質問をすべて見る
            <i className="ri-arrow-right-line"></i>
          </a>
        </FadeInSection>
      </div>
    </section>
  );
}